import { isDevMode } from "@angular/core";
import type { Routes } from "@angular/router";
import { directoryRouteGuard } from "./guards/directory-route.guard";
import { homeRedirectGuard } from "./guards/home-redirect.guard";

export const routes: Routes = [
    {
        path: "",
        canActivate: [homeRedirectGuard],
        children: []
    },
    {
        path: ":locale",
        loadComponent: async () => import("./features/home/home.component").then((m) => m.HomeComponent),
        data: {
            pageType: "home"
        }
    },
    {
        path: ":locale/:slug",
        loadComponent: async () => import("./features/page/page.component").then((m) => m.PageComponent),
        data: {
            pageType: "page"
        }
    },
    {
        path: ":locale/:directorySegment/:searchSegment",
        loadComponent: async () =>
            import("./features/directory/search-results/search-results.component").then((m) => m.SearchResultsComponent)
    },
    {
        path: ":locale/:directorySegment/:typeSegment/:slug",
        loadComponent: async () => import("./features/directory/directory.component").then((m) => m.DirectoryComponent),
        canActivate: [directoryRouteGuard]
    },
    ...(isDevMode()
        ? [
              {
                  path: "stylesheet",
                  loadComponent: async () =>
                      import("./features/stylesheet/stylesheet.component").then((m) => m.StylesheetComponent)
              }
          ]
        : []),
    {
        path: ":slugOrLocale",
        loadComponent: async () => import("./features/page/page.component").then((m) => m.PageComponent),
        data: {
            pageType: "page"
        }
    },
    {
        path: "**",
        loadComponent: async () => import("./features/not-found/not-found.component").then((m) => m.NotFoundComponent)
    }
];
